export interface Company {
  id: number;
  nif: string;
  nome?: string;
  nome_curto?: string;
  tipo?: "empresa" | "individual" | "gov" | "outro";
  email?: string;
  telefone?: string;
  morada?: string;
  codigo_postal?: string;
  cidade?: string;
  pais?: string;
  website?: string;
  logo_url?: string;
  notas?: string;
  fonte?: "VIES" | "OpenCorporates" | "NIF.PT" | "manual" | "importacao";
  verificado?: boolean;
  necessita_preenchimento?: boolean;
  ativo?: boolean;
  criado_em?: string;
  atualizado_em?: string;
}

export interface CompanyStats {
  total: number;
  ativas: number;
  necessitam_preenchimento: number;
  verificadas: number;
  por_fonte: Array<{ fonte: string; count: number }>;
  por_tipo: Array<{ tipo: string; count: number }>;
  recentes: number;
}

export const COMPANY_TIPO_LABELS: Record<string, string> = {
  empresa: "Empresa",
  individual: "Individual",
  gov: "Governo",
  outro: "Outro",
};

export const COMPANY_FONTE_LABELS: Record<string, string> = {
  VIES: "VIES (UE)",
  OpenCorporates: "OpenCorporates",
  "NIF.PT": "NIF.PT",
  manual: "Manual",
  importacao: "Importação",
};
